import { CardActionArea } from "@mui/material";
import { useHistory } from "react-router-dom";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH } from "../../ShiftDiscovery/paths";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { VisitCardContent } from "../Card/Content";
import { type PatientData, type VisitWithCaseData } from "../types";
import { useLogOpenVisitViewed } from "./useLogOpenVisitViewed";

interface InHomeOpenVisitCardProps {
  visit: VisitWithCaseData;
  patient: PatientData | undefined;
  specialties: string[];
  workplaceName: string;
  workplaceId: string;
}

export function InHomeOpenVisitCard(props: InHomeOpenVisitCardProps) {
  const { visit, patient, specialties, workplaceName, workplaceId } = props;
  const history = useHistory();
  const { generateModalPath } = useInHomeVisitModalsDataContext();

  const { ref } = useLogOpenVisitViewed({
    visitId: visit.id,
    workplaceId,
    visitType: visit.attributes.type,
    workerReq: visit.attributes.workerReq,
    payRate: visit.attributes.payRate?.amountInMinorUnits,
    pricingType: visit.attributes.pricingType,
    distanceInMiles: patient?.attributes.distanceToWorkerInMiles,
  });

  return (
    <ShiftCardWrapper>
      <CardActionArea
        ref={ref}
        sx={{ flexGrow: 1 }}
        onClick={() => {
          history.push(
            generateModalPath(SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH, {
              visitId: visit.id,
              caseId: visit.attributes.caseId,
            })
          );
        }}
      >
        <VisitCardContent
          visit={visit}
          patient={patient}
          specialties={specialties}
          workplaceName={workplaceName}
        />
      </CardActionArea>
    </ShiftCardWrapper>
  );
}
